import {  DetailPageActionType, DetailPagePropsType, BreadCrumbType } from '../../datatypes/datatypes';
import { strings } from "../../services/Localization";
import { faList } from '@fortawesome/pro-regular-svg-icons'
import { getAppBase, getLabelBasedOnServerType } from '../../utils/consts';
import {  TAB_ADD_NOTIFICATION_POLICY, TAB_NOTIFICATION_POLICY_INFO  } from '../../datatypes/tabsconstants'



const addPageNav = ( navigate, tab) => {
    
    navigate( `${getAppBase()}/notificationpolicy/${tab}`, {state: {tab: tab, prevPageUrl: `${getAppBase()}/notificationpolicy`}})
}


const detailPageNav = ( actionArgs ) => {

    const { navigate, tab, id, row } = actionArgs;
    let prevPageUrl = actionArgs.hasOwnProperty('prevPageUrl') ? actionArgs['prevPageUrl'] : null;
    navigate(`${getAppBase()}/notificationpolicy/${id}/${tab}`, {state: { row: row, prevPageUrl:prevPageUrl}})
}


export const NotificationPolicyAddProps:DetailPagePropsType =  {
    getBreadCrumbArr: ( breadCrumbArgs ) => {
        let prevPageUrl = breadCrumbArgs.hasOwnProperty('prevPageUrl') ? breadCrumbArgs['prevPageUrl'] : '-1';

        const breadCrumb:BreadCrumbType[] = [
            getLabelBasedOnServerType(strings.NAV_ALERTS, '',  prevPageUrl),
            {label: strings.NAV_MANAGE_NOTIFICATION_POLICY,  url: prevPageUrl},
            {label: strings.ADD_NOTIFICATION_POLICY,  url:''}
        ]
        return breadCrumb;
    },    
    getActions : (actionArgs, navigate) => {
        
        let prevPageUrl = actionArgs.hasOwnProperty('prevPageUrl') ? actionArgs['prevPageUrl'] : '-1';

        const actions: DetailPageActionType[] = [
            {
                type: "tab",
                text: strings.ADD_NOTIFICATION_POLICY,
                icon: faList,
                key: TAB_ADD_NOTIFICATION_POLICY,
                action: (id) => addPageNav(navigate, TAB_ADD_NOTIFICATION_POLICY),
                content: {
                    type: 'SchemaModal',
                    url:'/rest/notification-policies?get_schema=dassui,post',
                    backUrl: prevPageUrl
                }
            }                 
            
        ]

        return actions;
    }
}

export const NotificationPolicyEditProps:DetailPagePropsType =  {

    getBreadCrumbArr: ( breadCrumbArgs ) => {
        
        let id = breadCrumbArgs.hasOwnProperty('id') ? breadCrumbArgs['id'] : 0;
        let notificationPolicyName = breadCrumbArgs?.row?.name || "";
        let prevPageUrl = breadCrumbArgs.hasOwnProperty('prevPageUrl') ? breadCrumbArgs['prevPageUrl'] : '';
        return [
            getLabelBasedOnServerType(strings.NAV_ALERTS, '',  prevPageUrl),
            {label: strings.NAV_MANAGE_NOTIFICATION_POLICY, url: prevPageUrl}, 
            { label: notificationPolicyName, url:'', comment: id}
        ]
    },

    getActions : (actionArgs, navigate) => {

        let prevPageUrl = actionArgs.hasOwnProperty('prevPageUrl') ? actionArgs['prevPageUrl'] : '-1';
        const { row } = actionArgs;
        const notificationPolicyUuid = row.hasOwnProperty('notificationPolicyUuid') ? row.notificationPolicyUuid : (row.hasOwnProperty('notificationPolicyUuid') ? row.notificationPolicyUuid : null);
                
        const actions:DetailPageActionType[] = [
            {
                type: "tab",
                text: strings.EDIT_NOTIFICATION_POLICY,
                icon: faList,
                key: TAB_NOTIFICATION_POLICY_INFO,
                action: (row) => detailPageNav({ navigate: navigate, tab:TAB_NOTIFICATION_POLICY_INFO, id:notificationPolicyUuid, row:row, prevPageUrl:prevPageUrl}),
                content: {
                    type: 'SchemaModal',
                    url:'/rest/notification-policies?get_schema=dassui,put',
                    backUrl: prevPageUrl
                },
                EditObject: notificationPolicyUuid ? { notificationPolicyUuid } : null
            }
        ]

        return actions;
    }
}





